// src/config/globalProperties.js

import axios from 'axios';
import messageService from '@/services/messages.js';

export async function loadAppConfig(app) {
    try {
        // Requisições paralelas
        const [configRes, versionRes] = await Promise.all([
            fetch('/config'),
            fetch('/version'),
        ]);

        const config = configRes.ok ? await configRes.json() : {};
        const versionJson = versionRes.ok ? await versionRes.json() : {};
        const appName = config.APP_NAME;
        const version = versionJson?.[appName]?.version;

        const finalConfig = {
            ...config,
            version,
        };

        // Injetar nas propriedades globais do Vue
        app.config.globalProperties.APP_NAME = finalConfig.APP_NAME;
        app.config.globalProperties.URL_API_BASE_AUTH = finalConfig.URL_API_BASE_AUTH;
        app.config.globalProperties.URL_API_BASE_CONTRACT = finalConfig.URL_API_BASE_CONTRACT;
        app.config.globalProperties.URL_API_BASE_ISP = finalConfig.URL_API_BASE_ISP;
        app.config.globalProperties.URL_API_BASE_RH = finalConfig.URL_API_BASE_RH;
        app.config.globalProperties.URL_API_BASE_CHECKIN = finalConfig.URL_API_BASE_CHECKIN;
        app.config.globalProperties.URL_API_BASE_QRCODE = finalConfig.URL_API_BASE_QRCODE;
        app.config.globalProperties.version = finalConfig.version;
        app.config.globalProperties.message = messageService;
        app.config.globalProperties.API_AUTH = finalConfig.URL_API_BASE_AUTH;
        app.config.globalProperties.APP_ENV = finalConfig.APP_ENV;
        app.config.globalProperties.LIBERTY_MOCK = finalConfig.LIBERTY_MOCK;

        // add no window para usar fora do Vue
        window.appConfig = finalConfig;
        window.message = messageService;
        window.URL_API_BASE_RH = finalConfig.URL_API_BASE_RH;
        window.API_AUTH = axios.create({
            baseURL: finalConfig.URL_API_BASE_AUTH || '',
        });
        window.APP_ENV = finalConfig.APP_ENV;
        window.API_CONTRACT = axios.create({
            baseURL: finalConfig.URL_API_BASE_CONTRACT || '',
        });
        window.LIBERTY_MOCK = finalConfig.LIBERTY_MOCK;
        window.API_ISP = axios.create({
            baseURL: finalConfig.URL_API_BASE_ISP || '',
        });
        window.API_RH = axios.create({
            baseURL: finalConfig.URL_API_BASE_RH || '',
        });
        window.API_CHECKIN = axios.create({
            baseURL: finalConfig.URL_API_BASE_CHECKIN || '',
        });
        window.API_QRCODE = axios.create({
            baseURL: finalConfig.URL_API_BASE_QRCODE || '',
        });
        return finalConfig;
    } catch (error) {
        console.error("Erro ao carregar configurações da aplicação:", error);
        return null;
    }
}
